import React from 'react';
import { SolutionProvider } from '@/context/solution.context';

const withSolution = ({ host, children }) => {
  return <SolutionProvider host={host}>{children}</SolutionProvider>;
};

export default withSolution;
